"use client";
/*
 * Documentation:
 * DC_Excursion_Actions — https://app.subframe.com/4f62853ee923/library?component=DC_Excursion_Actions_d829c949-f459-4689-8d70-67fac82b1b07
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Dc_Excursion_ActionsRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  breadcrumbsSlot?: React.ReactNode;
  closeSlot?: React.ReactNode;
  className?: string;
}

const Dc_Excursion_ActionsRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Excursion_ActionsRootProps
>(function Dc_Excursion_ActionsRoot(
  {
    breadcrumbsSlot,
    closeSlot,
    className,
    ...otherProps
  }: Dc_Excursion_ActionsRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex w-full items-center justify-between",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex items-center justify-between">
        {breadcrumbsSlot ? (
          <div className="flex items-center justify-between">
            {breadcrumbsSlot}
          </div>
        ) : null}
      </div>
      {closeSlot ? (
        <div className="flex items-center justify-between">{closeSlot}</div>
      ) : null}
    </div>
  );
});

export const Dc_Excursion_Actions = Dc_Excursion_ActionsRoot;
